import { render, staticRenderFns } from "./dashboardnew.vue?vue&type=template&id=a573832e&scoped=true&"
import script from "./dashboardnew.vue?vue&type=script&lang=js&"
export * from "./dashboardnew.vue?vue&type=script&lang=js&"
import style0 from "./dashboardnew.vue?vue&type=style&index=0&id=a573832e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a573832e",
  null
  
)

export default component.exports